import {
  type Layer,
  type StandardChartLayerSpec,
  defineStandardChartLayer
} from '../../../core/layer';
import DEFINE from '../../../util/DEFINE';

const visInfo: Layer['visInfo'] = {
  id: 'polarBar',
  name_en: 'Polar Bar',
  // name_zh: '极坐标柱状图',
  types_en: [],
  purpose_en: [],
  purpose_zh: [],
  standers: '',
  rules: {
    x: amount => amount > 1,
    y: amount => amount > 1,
    data: amount => amount < 30
  },
  /** 保证和 Spec.encoding 字段一致 */
  parameters: {
    x: {
      itemType: [DEFINE.STR, DEFINE.DATE],
      category: DEFINE.SINGLE
    },
    y: {
      itemType: [DEFINE.NUMBER],
      category: DEFINE.SINGLE
    }
  }
};

export interface Spec extends StandardChartLayerSpec {
  encoding: {
    x: string;
    y: string;
  };
}

export const polarBar = defineStandardChartLayer<Spec>({
  type: visInfo.id,
  isIndependentLayer: true,
  visInfo,
  render(api, spec) {
    const { data: dataArray, util, hook } = api;
    const presetOption = hook.buildStandardChartPresetOption(api);
    const {
      dataIndex = 0,
      encoding: { x, y }
    } = spec;
    const data = dataArray[dataIndex];
    const dataMetaInfo = hook.parseDataMetaInfo(data);

    // * ------------------------- data
    const { x: radiusAxisData, y: valueData } = util.dataEncoding.encoding(data.values.slice(), {
      x: { field: x },
      y: {
        field: y,
        transformers: [{ type: 'toNumeric' }]
      }
    });
    let valueMax = Math.max(...valueData);
    valueMax *= 1.2;

    // * ------------------------- chart
    const baseGridOption = Array.isArray(presetOption.grid)
      ? presetOption.grid[0]
      : presetOption.grid!;
    return {
      grid: {
        ...baseGridOption
      },
      xAxis: [],
      yAxis: [],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'none'
        },
        formatter: params_ => {
          const items = [];
          params_.forEach(item => {
            const value = hook.formatDataNumberValue(item.value, {
              type: 'table',
              unit: dataMetaInfo[item.seriesName]?.unit
            });
            items.push({
              type: util.const.SERIES_2_LEGEND_TYPE_MAP.polarBar,
              color: item.color,
              name: y,
              value: value.value + value.unit
            });
          });
          // prettier-ignore
          return hook.buildTooltip({
            config: hook.buildStandardChartPresetOption(api).tooltip,
            title: params_[0]?.axisValueLabel,
            items
          });
        }
      },
      polar: {
        show: true
      },
      angleAxis: {
        show: true,
        max: valueMax,
        axisLabel: {
          showMaxLabel: false,
          hideOverlap: true,
          fontFamily: presetOption.textStyle.fontFamily
        }
      },
      radiusAxis: {
        show: true,
        name: x,
        nameGap: 32,
        type: 'category',
        data: radiusAxisData,
        axisLabel: {
          hideOverlap: true,
          fontFamily: presetOption.textStyle.fontFamily
        }
      },
      series: [
        {
          type: 'bar',
          data: valueData,
          name: y,
          coordinateSystem: 'polar',
          label: {
            show: valueData.length < 5,
            position: 'middle',
            formatter: '{b}: {c}'
          }
        }
      ]
    };
  }
});
